import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/wmz9dywcZgvD2T4jSQBAWL/BONUS_1.png',
  title: 'Pack de Plantillas',
  desc: 'Control sin obsesión (Sheets/Excel)'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ofWrPNoG22NWQGqEuXMaze/bonus_2.png',
  title: 'Lista Maestra',
  desc: '10 fugas típicas + reemplazos'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6BfsXZgtWm4kMfQ7agGCG2/bonus_3.png',
  title: 'Guía Semana Difícil',
  desc: 'Protocolo 20 min (Modo Supervivencia)'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/vm8gFw8ZoxpwRsrxFsqyqk/bonus_4.png',
  title: 'Guía Compras Impulsivas',
  desc: 'Reglas simples (Sin culpa)'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kaioEPqspoqTTd9cd1h34L/bonus_5.png',
  title: 'Mini-Guía Tarjeta sin Pánico',
  desc: '5 pasos para ordenarte'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/fQVpxoo7CBKPeJNaV8KRt9/bonus_6.png',
  title: 'Calendario de Cierres',
  desc: '12 semanas en orden (Revisión guiada)'
}];
export function Bonuses() {
  return <section className="py-10 bg-[#F3F6FA]" data-id="element-15">
      <div className="container mx-auto px-4 bg-[#053F63] rounded-2xl py-8" data-id="element-16">
        <div className="text-center max-w-3xl mx-auto mb-6" data-id="element-17">
          <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight mb-1 bg-[#0C0B0B] inline-block px-4 py-1 rounded-lg" data-id="element-18">
            🎁 BONOS ESTRATÉGICOS 🎁
          </h2>
          <p className="text-xs font-bold uppercase tracking-wide text-[#F3EDED] mt-2" data-id="element-19">
            Incluidos con tu sistema
          </p>
        </div>

        {/* 2 rows of 3 bonuses */}
        <div className="grid grid-cols-3 gap-2 md:gap-4 max-w-4xl mx-auto mb-6" data-id="element-20">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white rounded-xl p-2.5 md:p-3 text-center flex flex-col items-center" data-id="element-21">
              <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-lg mb-2 shadow-sm" data-id="element-22" />
              <h3 className="font-black text-black text-[11px] md:text-xs leading-tight mb-0.5" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-[9px] md:text-[10px] text-slate-400 leading-tight" data-id="element-24">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-25">
          <div className="inline-block bg-white/15 backdrop-blur-sm text-white px-4 py-2 rounded-full font-bold text-xs border border-white/30" data-id="element-26">
            Valor total bonos:{' '}
            <span className="line-through text-blue-200 mr-1" data-id="element-27">$49.999</span>
            <span className="text-yellow-300 font-black" data-id="element-28">
              → INCLUIDOS GRATIS
            </span>
          </div>
        </div>
      </div>
    </section>;
}